module.exports = __webpack_public_path__ + "static/media/moment08.a9f69cb4.webp";